import React, { useEffect } from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { checkAndRedirect } from '../utils';
import Layout from '../components/Layout/LayoutContainer';
import { logout } from '../actions/user';
import UnAuth401 from '../components/Unauthorised/Unauthorised';
import NotFound404 from '../components/Errors/NotFound404';
import { getIsUserAuthenticated, getUserOrgModelCategoryType } from '../selectors/index';
import AppLoading from '../components/AppLoading/AppLoading';
import { getSelectedUserProfileWidgets } from '../actions/UserProfileWidgets';
import { IsWidgetAccessible } from '../utils/widgetManager';
import Unauth from '../hocs/unauthorized';

import { ModelCategoryPermission } from '../constants';
import { getModelCategoryPermission } from '../utils';



/**
 * AuthenticatedLayout - Layout component for authenticated pages
 * Wraps authenticated content with the sidebar and navbar
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component/page to render inside the layout
 */
const AuthenticatedLayout = ({ pageAccessCode, accessCodes, children, permission=null}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  let isAuthenticated = getIsUserAuthenticated();
  let { ModelCategoryId } = useParams();
  

  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  const selectedProfileid = Cookies.get(`selectedprofileid-${envName}`) || 0;
  const userName = Cookies.get(`username-${envName}`) || '';

  const userProfileWidgetsPresent = useSelector(state => state.userProfileWidgets.isProfileWidgetsPresent);
  const isLoading = useSelector(state => state.userProfileWidgets.isLoading);
  const userProfileWidgets = useSelector(state => state.userProfileWidgets);
  const userModelCategories = useSelector(state => getUserOrgModelCategoryType(state));

  let isModelCategoryAccess = true 
  if(ModelCategoryId && permission) {
    isModelCategoryAccess = getModelCategoryPermission(userModelCategories, ModelCategoryId, permission)
  }
  

  useEffect(() => {

    if (getIsUserAuthenticated() && !userProfileWidgetsPresent) {
      dispatch(getSelectedUserProfileWidgets(selectedProfileid, userName, 'GENERALACCESS'));
    }
  }, [dispatch, userProfileWidgetsPresent, isAuthenticated, selectedProfileid, userName]);

  // If user is not authenticated, redirect to login
  if (!getIsUserAuthenticated() || !selectedProfileid || !userName) {
    return <Navigate to="/login" replace />;
  }

  const dispathLogout = () => {
    dispatch(logout())
  }

  // Show loading while fetching user profile widgets
  if (isLoading) {
    return <AppLoading />;
  }
  // Check page access
  const pageAccess = IsWidgetAccessible(userProfileWidgets, pageAccessCode);
  // Check additional access codes if provided
  let status = false;
  if (accessCodes) {
    for (let i = 0; i < accessCodes.length; i++) {
      status = IsWidgetAccessible(userProfileWidgets, accessCodes[i]);
      if (status) break;
    }
  }

  // Render the appropriate component based on access permissions
  if (pageAccess && status && isModelCategoryAccess && !isLoading) {
    return isAuthenticated ? (
      <Layout isAuthenticated={isAuthenticated} logout={dispathLogout} location={location}>
        {children}
      </Layout>
    ) : <NotFound404 />
  } else if ((!pageAccess || !status || !isModelCategoryAccess) && !isLoading && userProfileWidgetsPresent) {
    return <UnAuth401 />;
  } else {
    return <AppLoading />;
  }

};

export default AuthenticatedLayout;